import { styled } from '@mui/system';
import { Typography, Button, FormHelperText } from '@mui/material';

import { isObjectEmpty, isStringEmpty } from 'utils';

import { ItemsButtonList, SearchField, SvgPlaceholder } from 'components/core';
import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';

// import { TitleStyle } from 'screens/styles';
// import { IconSadSearchHandsUp } from 'assets/icons';


const SelectOptionRoot = styled('div', {target: 'SelectOptionRoot'})(({theme}) => ({
  marginBottom: theme.spacing(1)
}))

// const SEARCH_FIELD_OPTION_LENGTH = 1
const ClearButton = styled(Button, { target: 'ClearButton' })(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.vars.palette.primary.main,
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginLeft: theme.spacing(1)
}));

// const TypographyAndSearch = styled('div', {target: 'TypographyAndSearch'})(({theme}) => ({
//   marginBottom: '-5px'
// }))

export const SelectOption = ({
  isLoading,
  selectedOption,
  searchOptionValue,
  isListView,
  options,
  label,
  title,
  subTitle,
  placeholder,
  buttonSeeAll,
  helperText,
  warningText,
  handleSearchOptionValue,
  handleSelectedOption,
  selectOptionType
}) => {
  const { t } = useOnlineBookingLocale();

  // seeAll = seeAll && options?.length > 1 && `${buttonSeeAll} (${options.length})`;

  // const filteredOptions = isStringEmpty(searchOptionValue) ? options
  // : options?.filter((Option) =>
  //     Option?.name?.toLowerCase().includes(searchOptionValue.toLowerCase()) ||
  //     Option?.publicName?.toLowerCase().includes(searchOptionValue.toLowerCase())
  //   )


  // const filteredOptions =  !isObjectEmpty(selectedOption) ? [selectedOption] : isStringEmpty(searchOptionValue) ? options
  // : options?.filter((Option) =>
  //     Option?.name?.toLowerCase().includes(searchOptionValue.toLowerCase()) ||
  //     Option?.publicName?.toLowerCase().includes(searchOptionValue.toLowerCase())
  //   )


  return (
    <SelectOptionRoot>
      <ItemsButtonList
        {...{isLoading, isListView }}
        cancelOption
        options={options}
        optionSelected={selectedOption}
        onSelectOption={handleSelectedOption}
        selectOptionType={selectOptionType}
        title={title}
        subTitle={subTitle}
        warningText={warningText}
      />
        <div style={{ display: 'block' }}>
        {!isObjectEmpty(options) && <ClearButton
          title={t('ariaLabel.clear')}
          aria-describedby="clear-description"
          disabled={isObjectEmpty(selectedOption)}
          size="small"
          onClick={() => {
            handleSelectedOption({});
            handleSearchOptionValue('');
            const feedbackEl = document.getElementById("clear-feedback");
            if (feedbackEl) {
              feedbackEl.textContent = '';
              setTimeout(() => {
                feedbackEl.textContent = selectedOption?.name
                  ? `${t('ariaLabel.clear')} ${selectedOption.name}`
                  : `${t('ariaLabel.clear')}`;
              }, 50);
            }
          }}
          role="button"
        >
          {t('ariaLabel.clear')}
        </ClearButton>}
      </div>

      <div
        id="clear-feedback"
        aria-live="polite"
        style={{
          position: "absolute",
          left: "-9999px",
          height: "1px",
          width: "1px",
          overflow: "hidden"
        }}
      >
        {/* this will be filled dynamically */}
      </div>
    </SelectOptionRoot>
  );
};

export default SelectOption;
